import { css } from '@emotion/react';
import { type FC } from 'react';
import { computeButtonFontSize } from '~/_shared/baseComponents/buttons';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';
import {
  ButtonSize, ButtonStyle,
} from '~/_shared/baseComponents/buttons/button/button.types';
import { LoaderComponent } from '~/_shared/baseComponents/loaders';

type AuthorizationButtonProps = Readonly<{
  className?: string;
  'data-testid'?: string;
  isLoading: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  buttonStyle?: ButtonStyle;
  size?: ButtonSize;
  isSubmit?: boolean;
}>;

type AuthorizationSubmitButtonProps = Omit<AuthorizationButtonProps, 'isSubmit' | 'buttonStyle'>;

const buttonElementStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const loaderStyle = css({
  marginRight: 20,
});

export const AuthorizationSubmitButtonComponent: FC<AuthorizationSubmitButtonProps> = (props) => {
  return (
    <AuthorizationButtonComponent
      isSubmit
      buttonStyle={ButtonStyle.Primary}
      {...props}
    />
  );
};

export const AuthorizationButtonComponent: FC<AuthorizationButtonProps> = (props) => {
  const { className, isSubmit, isLoading, isDisabled, onClick, children, buttonStyle, size = ButtonSize.Large, 'data-testid': dataTestId } = props;

  return (
    <ButtonComponent
      isSubmit={isSubmit}
      className={className}
      css={buttonElementStyles}
      buttonStyle={buttonStyle}
      size={size}
      onClick={onClick}
      data-testid={dataTestId}
      text={(style) => (
        <>
          {isLoading && (
            <LoaderComponent
              color={style.textColor}
              css={loaderStyle}
              size={computeButtonFontSize({ size }) + 2}
            />
          )}
          {children}
        </>
      )}
      isDisabled={isDisabled || isLoading}
    />
  );
};
